import React from 'react';
import { MobileModal } from '../../Modules';
import { Button, Modal } from 'semantic-ui-react';
import documentStyles from '../../Document/Document.scss';
import PropTypes from 'prop-types';
import styleVariables from '../../variables';
import AcceptedPaymentMethods from './AcceptedPaymentMethods';

export default class NoPaymentMethods extends React.Component {
  static propTypes = {
    onClose: PropTypes.func.isRequired,
    open: PropTypes.bool.isRequired,
    relay: PropTypes.object.isRequired,
    viewer: PropTypes.object.isRequired,
    node: PropTypes.object.isRequired
  };

  constructor(props) {
    super(props);
    this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
  }

  componentWillMount() {
    this.updateWindowDimensions();
  }

  componentDidMount() {
    window.addEventListener('resize', this.updateWindowDimensions);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateWindowDimensions);
  }

  updateWindowDimensions() {
    this.setState({
      window: { width: window.innerWidth, height: window.innerHeight }
    });
  }

  render() {
    const helperText = (
      <h3 style={{ marginBottom: '2em' }}>
        Please select one or more ways to get paid
      </h3>
    );

    return (
      <div>
        {this.state.window.width >= styleVariables.tabletBreakpoint &&
          <Modal
            open={this.props.open}
            onClose={this.props.onClose}
            size='small'
          >
            <Modal.Header content='Enable Payment Methods' />
            <Modal.Content>
              {helperText}
              <AcceptedPaymentMethods
                viewer={this.props.viewer}
                relay={this.props.relay}
                node={this.props.node}
              />
            </Modal.Content>
            <Modal.Actions>
              <a
                onClick={this.props.onClose}
                className={documentStyles.modalSecondaryAction}
              >
                Cancel
              </a>
              <Button
                primary
                type='submit'
                disabled={
                  this.props.viewer.payment_methods.edges.filter(
                    node => node.enabled
                  ).length === 0
                }
                onClick={() => this.refs.form.submit()}
              >
                Next
              </Button>
            </Modal.Actions>
          </Modal>}
        {this.state.window.width < styleVariables.tabletBreakpoint &&
          <MobileModal open={this.props.open} onClose={this.props.onClose}>
            <MobileModal.Header>
              <div className='menu'>
                <a className='item' onClick={this.props.onClose}>
                  Cancel
                </a>
              </div>
              <div className='right menu'>
                <a className='item' onClick={() => this.refs.form.submit()}>
                  Save
                </a>
              </div>
            </MobileModal.Header>
            <MobileModal.Content>
              {helperText}
              <AcceptedPaymentMethods
                viewer={this.props.viewer}
                relay={this.props.relay}
                node={this.props.node}
              />
            </MobileModal.Content>
          </MobileModal>}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./webpack/components/App/PaymentMethods/NoPaymentMethods.js